import { ITreatmentMonitoring, ITreatmentMonitoringDetail } from "../../views/components/treatment-monitoring";
import { NotificationModel, PostModel, UserModel } from "../../apis";

export interface UserState {
  email: string;
  spUser: SpUser;
  user: UserModel | any;
  treatmentMonitoring: ITreatmentMonitoring[];
  treatmentMonitoringDetail: ITreatmentMonitoringDetail;
  alarms: NotificationModel[];
  about: PostModel;
  license: PostModel;
  history?: any;
}

export interface SpUser {
  email?: string;
  fullName?: string;
  token?: string;
}

const user = {
  state: {
    email: '',
    user: {},
    spUser: {
    },
    treatmentMonitoring: [],
    treatmentMonitoringDetail: {
      bool: {},
      number: {}
    },
    alarms: [],
    about: {},
    license: {},
    history: {}
  } as UserState,

  getters: {
    email: (state: UserState) => state.email,
    spUser: (state: UserState) => state.spUser,
    user: (state: UserState) => state.user,
    treatmentMonitoring: (state: UserState) => state.treatmentMonitoring,
    treatmentMonitoringDetail: (state: UserState) => state.treatmentMonitoringDetail,
    alarms: (state: UserState) => state.alarms,
    about: (state: UserState) => state.about,
    license: (state: UserState) => state.license,
    history: (state: UserState) => state.history,
  },

  mutations: {
    SET_SP_USER_INFO: (state: UserState, { email = "", token = "", fullName= "" }) => {
      state.spUser.token = token;
      state.spUser.email = email;
      state.email = email;
      state.spUser.fullName = fullName;
    },
    SET_USER_INFO: (state: UserState, payload: { user: UserModel }) => {
      state.user = payload.user || {};
    },
    SET_ALARMS: (state: UserState, payload: NotificationModel[]) => {
      state.alarms = payload;
    },
    SET_ABOUT: (state: UserState, payload: PostModel) => {
      state.about = payload;
    },
    SET_HISTORY: (state: UserState, payload: {name: string, data:any}) => {
      state.history[payload.name] = payload.data;
    },
    SET_LICENSE: (state: UserState, payload: PostModel) => {
      state.license = payload;
    },
    SET_TREATMENT_MONITORING: (state: UserState, payload: ITreatmentMonitoring[]) => {
      state.treatmentMonitoring = payload;
    },
    SET_TREATMENT_MONITORING_DETAIL_NUMBER: (state: UserState, payload: {unitId: string, params: string[]}) => {
      state.treatmentMonitoringDetail.number[payload.unitId] = payload.params;
    },
    SET_TREATMENT_MONITORING_DETAIL_BOOL: (state: UserState, payload: {unitId: string, params: string[]}) => {
      state.treatmentMonitoringDetail.bool[payload.unitId] = payload.params;
    },
  },
  actions: {
    // SpUserInfo: async (context, payload) => {
    //   context.commit('SET_SP_USER_INFO', payload);
    // }
    // Login user
    // LoginByEmail: async ({ commit, dispatch }, payload) => {
    //   try {
    //     const response = await loginByEmail(payload.email.trim(), payload.password);
    //     console.log('[vuex.user] LoginByEmail', payload, response);
    //     await commit('SET_TOKEN', response.user.token);
    //     await commit('SET_USER_INFO', response.user);
    //     await dispatch('GenerateRoutes', response.user);
    //   } catch (err) {
    //     console.warn('[vuex.user] LoginByEmail', err);
    //   }
    // },

    // GetUserInfo: async ({ commit, state }) => {
    //   console.log('[vuex.user] GetUserInfo');
    //   try {
    //     const response = await getUserInfo(state.token);

    //     // Since mockjs does not support custom status codes, it can only be hacked like this
    //     if (!response) {
    //       throw new Error('Verification failed, please login again.');
    //     }

    //     // Verify returned roles are a non-null array
    //     if (response.user.roles && response.user.roles.length === 0) {
    //       throw new Error('getInfo: roles must be a non-null array!');
    //     }

    //     commit('SET_USER_INFO', response.user);
    //   } catch (err) {
    //     console.warn('[vuex.user] GetUserInfo', err);
    //   }
    // },

    // LogOut: async ({ commit }) => {
    //   try {
    //     console.log('[vuex.user] LogOut');
    //     await commit('SET_USER_INFO', { logout: true });
    //   } catch (err) {
    //     console.warn('[vuex.user] LogOut', err);
    //   }
    // },

    // Dynamically modify permissions
    /* ChangeRoles: async ({ commit, dispatch }, role) => {
      try {
        console.log('[vuex.user] ChangeRoles', role);
        await commit('SET_TOKEN', role);
        const data = await getUserInfo(role);
        await commit('SET_USER_INFO', data);
        // Redraw the side menu after dynamically modifying the permissions
        await dispatch('GenerateRoutes', data);
      } catch (err) {
        console.warn('[vuex.user] ChangeRoles', err);
      }
    }, */
  },
};

export default user;
